import React from 'react'
import {
  Container,
  Divider,
  Grid,
  Header,
  Image,
  List,
  Segment,
} from 'semantic-ui-react'
import {
  NavLink,
} from 'react-router-dom'
import logo from './cc.svg'

const PageFooter = ({basename}) => (
  <Segment inverted vertical style={{ margin: '6em 0em 0em 0em', padding: '2em 0em 6em 0em' }}>
    <Container textAlign='center'>
      <Grid divided inverted stackable>
        <Grid.Column width={3}>
          <Header inverted as='h4' content='Search...' />
          <List link inverted>
            <List.Item as={NavLink} to="/search">Outcomes</List.Item>
          </List>
        </Grid.Column>
        <Grid.Column width={3}>
          <Header inverted as='h4' content='List all...' />
          <List link inverted>
            <List.Item as={NavLink} to="/areas">Areas</List.Item>
            <List.Item as={NavLink} to="/units">Units</List.Item>
            <List.Item as={NavLink} to="/outcomes">Outcomes</List.Item>
          </List>
        </Grid.Column>
        <Grid.Column width={3}>
          <Header inverted as='h4' content='Conversion' />
          <List link inverted>
            <List.Item as={NavLink} to="/conversion/process">Conversion Process</List.Item>
            <List.Item as={NavLink} to="/conversion/mistakes">Mistakes in CS2013</List.Item>
            <List.Item as={NavLink} to="/conversion/ids">IDs</List.Item>
            <List.Item as='a' href={basename+"/cs2013.json"}>cs2013.json</List.Item>
          </List>
        </Grid.Column>
        <Grid.Column width={7}>
          <Header inverted as='h4' content='Which Curriculum?' />
          <p>
            This <i>unofficial</i> site allows you to explore
            the CS2013 <a href="https://www.acm.org/education/curricula-recommendations">Curriculum Guidelines for Undergraduate Degree Programs in Computer Science</a>.
          </p>
          <p>
            The CS2013 was developed by the
            The Joint Task Force on Computing Curricula by the ACM and IEEE.
          </p>
        </Grid.Column>
      </Grid>

      <Divider inverted section />
      <Image centered size='mini' src={logo} />
      <List horizontal inverted divided link size='small'>
        <List.Item as={NavLink} to='/contact'>
          Contact Us
        </List.Item>
        <List.Item as={NavLink} to='/terms'>
          Terms and Conditions
        </List.Item>
        <List.Item as={NavLink} to='/privacy'>
          Privacy Policy
        </List.Item>
      </List>
    </Container>
  </Segment>
)

export default PageFooter